var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/rrTray.j2"] = require( "macros/rrTray.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-right-rail.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/rrTray.j2", false, "product/templates/product-right-rail.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("richRelevanceTray")) {
var t_4 = t_1.richRelevanceTray;
} else {
cb(new Error("cannot import 'richRelevanceTray'")); return;
}
context.setVariable("richRelevanceTray", t_4);
output += "<div class=\"dom-product-right-rail c-right-rail ";
if(runtime.contextOrFrameLookup(context, frame, "isRightRailActive")) {
output += "s-right-rail o-column o-large--2";
;
}
else {
output += " is-hidden ";
;
}
output += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "isRightRailActive")) {
output += "data-qa-right-rail";
;
}
output += ">\n    <div class=\"o-row\">\n\n        <div class=\"o-row o-column o-large--12\">";
if(runtime.contextOrFrameLookup(context, frame, "isRightRailActive")) {
output += "\n\n                ";
output += runtime.suppressValue((lineno = 10, colno = 37, runtime.callWrap(t_4, "richRelevanceTray", context, [runtime.makeKeywordArgs({"anEntry": runtime.contextOrFrameLookup(context, frame, "None"),"rrRecs": (lineno = 12, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.rrRecs.pdp",(lineno = 12, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.rrRecs.item_page__bottom_1"]))])),"isRightRail": true})])), env.opts.autoescape);
output += "\n\n            ";
;
}
output += "</div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-right-rail.j2"] , dependencies)